import React, { useEffect } from "react"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import BreadcrumbsHeader from "components/views/atoms/BreadcrumbsHeader"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import TwoColumnRightPrimary from "components/views/atoms/layouts/TwoColumnRightPrimary"
import { useHistory } from "react-router"
import { TalkToCarrotLegal } from "./TalkToCarrotLegal"
import { SendMessage } from "./send-message/SendMessage"
import { H2, H5 } from "@carrotfertility/carotene"
import { Container } from "@carrotfertility/carotene"
import { BodySmall } from "../views/atoms/Bodies"
import { ArrowLink } from "../views/atoms/links/ArrowLink"
import Settings from "../../utils/CarrotConfig"
import { talkToCarrotSource } from "./send-message/SendMessageUtil"
import { useCurrentUser } from "../context/user/UserContext"
import { Spacer } from "../views/atoms/Atoms"

function lockedDownGetHelpContent() {
  return (
    <>
      <Container stack="medium">
        <H2 stack="tiny">{"Get help"}</H2>
        <BodySmall color="black-60">
          {`If you're having trouble with your account or otherwise need to reach a human, send us a message.`}
        </BodySmall>
      </Container>
      <Container>
        <H5 stack="tiny">{"Or you might like to..."}</H5>
        <ArrowLink to="/your-benefit-guide/about-your-benefit" color="black-60">
          Learn about your benefit
        </ArrowLink>
        <Spacer height={0.25} />
        <ArrowLink to={Settings.ZENDESK_GUIDE} color="black-60">
          Get answers to frequently asked questions
        </ArrowLink>
        <Spacer height={0.25} />
        <ArrowLink to="/carrot-plans/journey" color="black-60">
          Start using Carrot
        </ArrowLink>
      </Container>
    </>
  )
}

function LockedDownGetHelpPage() {
  const history = useHistory()
  const { isInAppLockdown } = useCurrentUser()

  useEffect(() => {
    if (!isInAppLockdown) {
      history.push("/")
    }
  }, [isInAppLockdown])

  return (
    <MasterLayout
      footer={<TalkToCarrotLegal />}
      header={
        <BreadcrumbsHeader
          breadcrumbs={[
            <Breadcrumb key="locked-down-help-breadcrumb" title={"Get help"} isActive={false} onClick={null} />
          ]}
        />
      }
    >
      <TwoColumnRightPrimary
        secondaryContent={lockedDownGetHelpContent()}
        primaryContent={<SendMessage source={talkToCarrotSource.LOCKED_DOWN_GET_HELP} />}
      />
    </MasterLayout>
  )
}

export { LockedDownGetHelpPage }
